<template>
  <div>
    <b-button class="margin-btn-5" @click="novoUsuario" variant="primary"
      >Novo Usuário</b-button
    >

    <div class="card card-custom gutter-b" style="margin-top: 20px;">
      <!--begin::Header-->
      <div class="card-header border-0 pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            Usuários Convidados
          </span>
          <span class="text-muted mt-3 font-weight-bold font-size-sm">
            Acompanhe os usuários que fazem parte do seu dashboard
          </span>
        </h3>
        <div class="card-toolbar">
          <div class="input-icon h-40px">
            <input
              type="text"
              class="form-control form-control-lg form-control-solid h-40px"
              v-model="filtroBusca"
              placeholder="Buscar..."
            />
            <span>
              <span class="svg-icon svg-icon-lg">
                <!--begin::Svg Icon-->
                <inline-svg src="media/svg/icons/General/Search.svg" />
                <!--end::Svg Icon-->
              </span>
            </span>
          </div>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div
        class="card-body pt-2 pb-0"
        style="max-height: 418px; overflow-y: auto; overflow-x: auto;"
      >
        <!--begin::Table-->
        <div class="table-responsive" style="overflow-x: initial;">
          <table class="table table-borderless table-vertical-center">
            <thead>
              <tr>
                <th class="p-0" style="width: 50px"></th>
                <th class="p-0" style="min-width: 150px"></th>
                <th class="p-0" style="min-width: 120px"></th>
                <th class="p-0" style="min-width: 70px"></th>
                <th class="p-0" style="min-width: 70px"></th>
                <th class="p-0" style="min-width: 50px"></th>
              </tr>
            </thead>
            <tbody v-if="usuarios.length">
              <template
                v-for="(item, i) in usuarios.slice(0, quantidadeExibir)"
              >
                <tr v-bind:key="i">
                  <td class="pl-0">
                    <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                      <span class="symbol-label">
                        <img
                          :src="
                            fgModoPR == 'R'
                              ? 'media/svg/avatars/001-boy.svg'
                              : 'media/svg/avatars/007-boy-2.svg'
                          "
                          class="h-75 align-self-end"
                          alt=""
                        />
                      </span>
                    </div>
                  </td>
                  <td class="pl-0">
                    <a
                      href="javascript:;"
                      @click="selecionarUsuario(item)"
                      class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                      :class="{
                        receber: fgModoPR == 'R',
                        pagar: fgModoPR == 'P'
                      }"
                    >
                      {{ item.EMAIL }}
                    </a>
                    <span class="text-muted font-weight-bold d-block">
                      {{ item.NOME ? item.NOME : item.USUARIO }}
                      <span v-if="!item.ACEITO || item.ACEITO == '0'">
                        <b-badge
                          class="mr-1"
                          variant="danger"
                          style="padding: 3px; padding-left: 5px; padding-right: 5px; margin-left: 5px;"
                        >
                          Não Confirmado
                        </b-badge>
                      </span>
                      <span v-if="item.MASTER && item.MASTER == '1'">
                        <b-badge
                          class="mr-1"
                          variant="success"
                          style="padding: 3px; padding-left: 5px; padding-right: 5px; margin-left: 5px;"
                        >
                          *MASTER*
                        </b-badge>
                      </span>
                      <span v-if="item.INATIVO">
                        <b-badge
                          class="mr-1"
                          variant="warning"
                          style="padding: 3px; padding-left: 5px; padding-right: 5px; margin-left: 5px;"
                        >
                          Inativo
                        </b-badge>
                      </span>
                    </span>
                  </td>
                  <td></td>
                  <td class="text-right">
                    <span
                      class="text-muted font-weight-bold d-block font-size-sm"
                    >
                      {{ retornaStatus(item) }}
                    </span>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    ></span>
                  </td>
                  <td class="text-right">
                    <span
                      class="text-muted font-weight-bold d-block font-size-sm"
                    >
                      Incluído
                    </span>
                    <span
                      class="font-weight-bolder text-primary"
                      :class="{
                        receber: fgModoPR == 'R',
                        pagar: fgModoPR == 'P'
                      }"
                    >
                      {{ formataData(item.DATA_INCLUSAO) }}
                    </span>
                  </td>
                  <td class="text-right pr-0">
                    <a
                      href="javascript:;"
                      @click="selecionarUsuario(item)"
                      class="btn btn-icon btn-light btn-sm"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-success">
                        <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Arrow-right.svg-->
                        <inline-svg
                          src="media/svg/icons/Navigation/Arrow-right.svg"
                        />
                        <!--end::Svg Icon-->
                      </span>
                    </a>
                  </td>
                </tr>
              </template>
              <template v-if="quantidadeExibir < usuarios.length">
                <tr>
                  <td colspan="6">
                    <a
                      href="javascript:;"
                      @click="exibirMais"
                      class="btn btn-block btn-sm btn-primary font-weight-bolder text-uppercase"
                      :class="{
                        receber: fgModoPR == 'R',
                        pagar: fgModoPR == 'P'
                      }"
                    >
                      Mostrar mais
                    </a>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-if="!usuarios.length">
              <tr>
                <td class="pl-0">
                  <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                    <span class="symbol-label">
                      <img
                        :src="
                          fgModoPR == 'R'
                            ? 'media/svg/avatars/001-boy.svg'
                            : 'media/svg/avatars/007-boy-2.svg'
                        "
                        class="h-75 align-self-end"
                        alt=""
                      />
                    </span>
                  </div>
                </td>
                <td class="pl-0">
                  <a
                    href="javascript:;"
                    class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >
                    Sem usuários convidados
                  </a>
                  <span class="text-muted font-weight-bold d-block">
                    ----
                  </span>
                </td>
                <td></td>
                <td class="text-right">
                  <span
                    class="text-muted font-weight-bold d-block font-size-sm"
                  >
                  </span>
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                </td>
                <td class="text-right">
                  <span class="font-weight-bolder text-primary"> </span>
                </td>
                <td class="text-right pr-0"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.text-hover-primary.pagar:hover {
  color: #f64e60 !important;
}

.text-hover-primary.receber:hover {
  color: #1bc5bd !important;
}

.text-primary.receber {
  color: #1bc5bd !important;
}

.text-primary.pagar {
  color: #f64e60 !important;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Usuarios",
  data() {
    return {
      quantidadeExibir: 10,
      filtroBusca: ""
    };
  },
  mounted() {
    let vm = this;

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Gerenciar Usuários" }]);

    if (vm.verificado) {
      vm.getUsuarios();
    } else {
      window.addEventListener(
        "autorizado",
        function() {
          vm.getUsuarios();
        },
        false
      );
    }
  },
  computed: {
    ...mapGetters(["verificado", "fgModoPR", "usuarios"]),
    dataToShow() {
      if (this.show === "month") return this.month;
      if (this.show === "week") return this.week;
      if (this.show === "day") return this.day;
      return this.day;
    }
  },
  methods: {
    ...mapActions(["getUsuarios"]),
    formataData(data) {
      return moment(data, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
    },
    exibirMais() {
      this.quantidadeExibir += 10;
    },
    novoUsuario() {
      this.$router.push("usuario");
    },
    retornaStatus(item) {
      if (item.INATIVO) {
        return "Inativo";
      } else {
        return "Ativo";
      }
    },
    selecionarUsuario(item) {
      this.$router.push("usuario/" + item.ID_EMITENTE_ML_USUARIO);
    }
  }
};
</script>
